import * as React from "react";

import { clsxm } from "@/lib/clsxm";

const TextButtonVariant = ["primary", "basic", "underlined"] as const;

type TextButtonProps = {
  variant?: (typeof TextButtonVariant)[number];
} & React.ComponentPropsWithRef<"button">;

export const TextButton = React.forwardRef<HTMLButtonElement, TextButtonProps>(
  (
    {
      children,
      className,
      variant = "primary",
      disabled: buttonDisabled,
      ...rest
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type="button"
        disabled={buttonDisabled}
        className={clsxm(
          "inline-flex items-center justify-center font-semibold",
          "focus:outline-none focus-visible:ring focus-visible:ring-primary-500",
          "transition duration-100",
          //#region  //*=========== Variant ===========
          variant === "primary" && [
            "text-primary-500 hover:text-primary-600 active:text-primary-700",
            "disabled:text-primary-200",
          ],
          variant === "basic" && [
            "text-gray-500 hover:text-gray-600 active:text-gray-800",
            "disabled:text-gray-300",
          ],
          variant === "underlined" && [
            "border-b border-dashed border-black text-gray-500 hover:text-gray-600 active:text-gray-800",
            "disabled:text-gray-300",
          ],
          //#endregion  //*======== Variant ===========
          "disabled:cursor-not-allowed disabled:brightness-105 disabled:hover:underline",
          className
        )}
        {...rest}
      >
        {children}
      </button>
    );
  }
);
